import PatientsLandingPageHeader from "./PatientsLandingPageHeader";
import { postData, apiUrl, imageBaseUrl } from "../Networking/Api";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { logPageView } from "../ga";
import ProviderLandingPageFooter from "./ProviderLandingPageFooter/ProviderLandingPageFooter";

function PatientsLandingPage() {
  const location = useLocation();

  useEffect(() => {
    logPageView(location.pathname);
  }, [location]);

  return (
    <>
      <div className="fixed top-0 left-0 w-full z-50 bg-white shadow-md">
        <PatientsLandingPageHeader />
      </div>
      <div className="pt-16">
        <Banner />
        <ProviderLandingPageFooter />
      </div>
    </>
  );
}

function Banner() {
  const [results, setResults] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [location, setLocation] = useState({ lat: null, lon: null });
  const [time, setTime] = useState(new Date().toLocaleTimeString());
  const [locationName, setLocationName] = useState("");
  const [timeZone, setTimeZone] = useState("");
  const navigate = useNavigate();

  // const GOOGLE_MAPS_API_KEY = "YOUR_GOOGLE_MAPS_API_KEY";
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (searchTerm) {
          const response = await postData("patients/patientsSearchBy", {
            searchData: searchTerm,
          });
          setResults(response.data);
          localStorage.removeItem("selectedSlot");
          localStorage.removeItem("selectedDate");
          localStorage.removeItem("selectedOptions");
        } else {
          setResults([]);
        }
      } catch (error) {
        // console.log('Error fetching data:', error);
      }
    };

    fetchData();
  }, [searchTerm]);
  useEffect(() => {
    getLocationFromIP();

    // Update the time every second
    const timer = setInterval(() => {
      setTime(new Date().toLocaleTimeString());
    }, 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(timer);
  }, []);

  const getLocationFromIP = async () => {
    try {
      var currentTimeZone = localStorage.getItem("currentTimeZone");
      // console.log("currentTimeZone----", currentTimeZone);

      if (
        currentTimeZone == "null" ||
        currentTimeZone == null ||
        currentTimeZone == ""
      ) {
        // console.log("if--->");
        try {
          const response = await fetch("https://ipapi.co/json/");
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await response.json();

          setLocation({
            lat: data.latitude,
            lon: data.longitude,
          });

          const locationName = `${data.city}, ${data.region_code}`;
          setLocationName(locationName);

          const timeZone = `${data.utc_offset}, ${data.timezone}`;
          setTimeZone(timeZone);
          localStorage.setItem("currentTimeZone", timeZone);
          console.log("time zone--->", timeZone);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      } else {
        // console.log("else--->");
        setTimeZone(JSON.parse(currentTimeZone));
        console.log("timeZone currentTimeZone-->", currentTimeZone);
        console.log("timeZone state-->", timeZone);
      }
    } catch (error) {
      console.error("Error fetching IP location:", error);
    }
  };
  // console.log("timeZone-->", timeZone);

  useEffect(() => {
    if (searchTerm) {
      const filtered = results.filter((result) =>
        result.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredResults(filtered);
    } else {
      setFilteredResults([]);
    }
  }, [searchTerm, results]);

  const handleResultClick = (result) => {
    const type = result.type;
    const name = result.name;
    navigate(`/bookAnAppoinment/${type}/${name}`);
  };

  const navigateToBooking = () => {
    console.log("currentDomain", window.location.origin);
    const currentDomain = window.location.origin;

    //const targetUrl = `${currentDomain}/bookAnAppoinmentThirdParty/clinicServices/126`;
    //const targetUrl = `${currentDomain}/bookAppoinment/capitalcitydental`;
    const targetUrl = `${currentDomain}/capitalcitydental/bookAppoinment`;
    window.location.href = targetUrl;
  };
  return (
    <section className="w-full z-2">
      <div className="container mx-auto px-4 py-12 md:flex md:gap-4 md:items-center">
        <div className="w-full">
          {/* <h1 className="text-center font-fontPoppins text-3xl xss:text-base sm:text-lg font-semibold">
            Get medical care starting just $18.90
          </h1> */}
          <div className="flex justify-center">
            <button
              className="bg-blueColor text-white font-bold px-8 py-3 mb-2 text-md rounded-full transition duration-100 hover:bg-black hover:text-blue-500"
              onClick={navigateToBooking}
            >
              Book Appointment: Demo
            </button>
          </div>
          <div
            style={{ display: "none" }}
            className="w-full flex items-center bg-white gap-2 p-2 justify-center border border-blueColor border-solid rounded-full shadow-sm mt-3"
          >
            <i className="fa-solid fa-search text-blueColor ms-2"></i>
            <input
              className="w-full h-9 focus:outline-none font-fontPoppins text-xs text-gray-500"
              type="text"
              placeholder="Search by symptom, service, provider, medical..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
           
            <span className="w-48 h-9 px-2 flex justify-center bg-gray-100 rounded-full items-center text-xs leading-normal ">
              <img src={"./loc.png"} width="24px" alt="Location Icon" />
              {/* Martins Ferry, OH */}
              {locationName}
            </span>
          </div>
          <div
            className="shadow-md z-5 rounded-lg absolute bg-white w-1/3 max-h-80 overflow-y-auto mx-3"
            style={{ width: "44%" }}
          >
            {filteredResults.map((result, index) => (
              <p
                className="p-2 pl-5 w-full hover:bg-blue-700 cursor-pointer"
                onClick={() => handleResultClick(result)}
                key={index}
              >
                {result.name}
              </p>
            ))}
          </div>
        </div>
        <div className="w-full text-right xss:mt-4 sm:mt-4">
          <img
            src={"./banner-image.png"}
            alt="logo"
            className="max-w-full ml-auto"
          />
        </div>
      </div>
    </section>
  );
}

export default PatientsLandingPage;
